import React from "react"
import ClientCard from "../../components/Cards/ClientCard"
// import {  trustedByTheseCompanies } from "../../components/data"

const Client = () => {
  return (
    <div className="client w-full py-12 lg:py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
        {/* Main Heading */}
        {/* <div className="text-center mb-12 lg:mb-16">
          <h1 className="primary__heading text-4xl sm:text-5xl lg:text-6xl font-black text-gray-900 mb-4">
            Our Clients
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by leading companies and featured in top media outlets
          </p>
        </div> */}

        {/* Trusted by these Companies Section */}
        {/* <section className="mb-16 lg:mb-20">
          <div className="mb-8 lg:mb-10">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
              Trusted by these Companies
            </h2>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
            {trustedByTheseCompanies.map((company, index) => (
              <ClientCard key={index} card={company} type="company" />
            ))}
          </div>
        </section> */}

        {/* Media Coverage Section */}
        {/* <section>
          <div className="mb-8 lg:mb-10">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
              Media Coverage
            </h2>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-6">
            {mediaCoverage.map((media, index) => (
              <ClientCard key={index} card={media} type="media" />
            ))}
          </div>
        </section> */}
      </div>
    </div>
  )
}

export default Client
